import { array, object, schema, string } from "@anna-money/anna-web-lib/serializer";

export class BusinessActivityData extends schema(
  {
    // id always present in GB and not present in AU, make it required after backend refactoring
    id: string().optional(),
    code: string(),
    description: string(),
    // industryCode is present in AU only
    industryCode: string().optional(),
  },
  "BusinessActivityData",
) {}

export class BusinessActivitiesData extends schema(
  {
    businessCodes: array(object(BusinessActivityData)),
  },
  "BusinessActivitiesData",
) {}
